import React, { Component } from "react";
import Category from "../components/Category";

export default class ShopPage extends Component {
  render() {
    return (
      <>
        <Category />
      </>
    );
  }
}
